import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Handle, Position } from '@xyflow/react';
import MoleculeInfo from '../ResultsTable/MoleculeInfo.js';
import ResultInfoText from '../ResultsTable/ResultInfoText.js';
import MoleculeNodeContent from './moleculeNodeContent.js';
 
 /// data: srcImg, name, marts, 
function MoleculeNode({ data }) {
  const onChange = useCallback((evt) => {
    console.log(evt.target.value);
  }, []);

 
  return (
    <div
      className="molecule-node"
      style={data.highlight ? { backgroundColor: data.highlight } : {}}
    >
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={false}
      />
      <MoleculeNodeContent data={data} />
      <Handle
        type="source"
        position={Position.Bottom}
        id="b"
        isConnectable={false}
      />
    </div>
  );
}
 
export default MoleculeNode;